import { FormInputProps } from '@microservices/wiskey-react-components'
import { GENERATOR_INPUT_TYPE, REGEX } from '@constants'
import { AutocompleteOption } from '@types'
import i18next from 'i18next'

type useInputsParams = {
  objectOptions: AutocompleteOption[]
  isEdit?: boolean
  existingCodes?: string[]
  currentCode?: string
}

export const useInputs = ({
  objectOptions,
  isEdit,
  existingCodes = [],
  currentCode,
}: useInputsParams) => {
  const searchFilterInputs: FormInputProps[] = [
    {
      name: 'code',
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      replacePattern: REGEX.MODEL_CODE_REPLACE_PATTERN,
      label: i18next.t('searchFilterForm.id.label') || 'Internal Id',
      placeholder: i18next.t('searchFilterForm.id.placeholder') || 'Enter internal id',
      rules: {
        required: true,
        validate: (value: string) => {
          if (!value || value.trim().length === 0) {
            return 'Internal Id is required'
          }
          if (isEdit && currentCode && value === currentCode) {
            return true
          }
          if (existingCodes.includes(value)) {
            return `Internal Id "${value}" is already used`
          }
          return true
        },
      },
      disabled: Boolean(isEdit),
    },
    {
      name: 'title',
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      placeholder: i18next.t('searchFilterForm.title.placeholder') || 'Filter Title',
      label: i18next.t('searchFilterForm.title.label') || 'Filter Title',
      rules: { required: true, validate: (value: string) => value.trim().length !== 0 },
    },
    {
      name: 'object',
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      label: i18next.t('searchFilterForm.object.label') || 'Object',
      placeholder: i18next.t('searchFilterForm.object.placeholder') || 'Select object',
      autocompleteOptions: objectOptions,
      MenuProps: { PaperProps: { sx: { maxHeight: 300 } } },
      rules: {
        required: true,
      },
    },
  ]

  return searchFilterInputs
}
